var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurniture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 9.00781C3.52653 9.00781 4.03523 9.21853 4.41031 9.5936C4.78538 9.96867 4.99609 10.4774 4.99609 11.0078V13.0078H14.9961V11.0078C14.9961 10.4774 15.2068 9.96867 15.5819 9.5936C15.957 9.21853 16.4657 9.00781 16.9961 9.00781C17.5265 9.00781 18.0352 9.21853 18.4103 9.5936C18.7854 9.96867 18.9961 10.4774 18.9961 11.0078V15.0078C18.9961 15.5382 18.7854 16.047 18.4103 16.422C18.0352 16.7971 17.5265 17.0078 16.9961 17.0078H2.99609C2.46566 17.0078 1.95695 16.7971 1.58188 16.422C1.20681 16.047 0.996094 15.5382 0.996094 15.0078V11.0078C0.996094 10.4774 1.20681 9.96867 1.58188 9.5936C1.95695 9.21853 2.46566 9.00781 2.99609 9.00781V9.00781Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99219 9V4C2.99219 3.20435 3.30826 2.44129 3.87087 1.87868C4.43348 1.31607 5.19654 1 5.99219 1H13.9922C14.7878 1 15.5509 1.31607 16.1135 1.87868C16.6761 2.44129 16.9922 3.20435 16.9922 4V9",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99609 17.0039V19.0039",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 17.0039V19.0039",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture);
export default __webpack_public_path__ + "static/media/furniture.7925bf1e3db48e8e012af2710639ce97.svg";
export { ForwardRef as ReactComponent };